export const SDK_ENDPOINT = 'sdk.fra-01.braze.eu'
export const SERVICE_WORKER_LOCATION = '/braze-service-worker.js'
export const BRAZE_SAFARI_PUSH_ID = 'web.backmarket.safari'
export const EVENT_PLATFORM = 'web'

// this cookie name is cached by Cloudflare, don't update it
// see `openworld` repository: https://github.com/BackMarket/openworld
export const BRAZE_CONSENT_COOKIE = 'braze_consent_updated'
